import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  keywords: {
    paddingTop: '1rem',
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingTop: 0,
      },
    },
  },
  editAgreementLink: {
    fontSize: pxToRem(14),
    fontWeight: 400,
  },
  pendingApprovalText: {
    fontWeight: 400,
  },
  contractActivity: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  activityContent: {
    background: 'transparent',
    boxShadow: 'none',
  },
  showMore: {
    float: 'right',
  },
  filtersList: {
    marginTop: pxToRem(24),
  },
  noMarginBottom: {
    marginBottom: 0,
  },
  attachments: {
    paddingTop: pxToRem(20),
  },
  activityShowing: {
    fontWeight: 400,
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    selectors: {
      '& span': {
        fontWeight: 600,
      },
    },
  },
  showMoreActivityButton: {
    float: 'right',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
  },
  showMoreActivity: {
    fontSize: pxToRem(14),
    cursor: 'pointer',
    marginTop: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  managerInfoBlock: {
    display: 'block',
    lineHeight: pxToRem(16),
  },
  royaltyFeeModule: {
    marginBottom: pxToRem(16),
    selectors: {
      '&:last-child': {
        marginBottom: pxToRem(40),
      },
    },
  },
  noRoyaltyFees: {
    marginBottom: pxToRem(40),
  },
  actionRequiredWrapper: {
    marginBottom: pxToRem(24),
    selectors: {
      ':empty': {
        display: 'none',
      },
    },
  },
  transactionsPaused: {
    marginBottom: pxToRem(24),
  },
  messageBarTitle: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
    marginTop: pxToRem(12),
  },
  messageBarBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  saving: {
    marginRight: pxToRem(16),
  },
  discardButton: {
    marginRight: pxToRem(16),
  },
  wordWrapBreakWord: {
    wordWrap: 'break-word',
  },
  moduleBottom: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralQuaternary}`,
  },
  moduleContent: {
    borderBottom: 'none',
  },
  calculation: {
    paddingBottom: pxToRem(10),
  },
  advanceGroupCard: {
    marginBottom: 0,
    marginTop: 0,
  },
  detailsRowStyle: {
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  contractCard: {
    padding: pxToRem(16),
  },
  calloutDisplayContainer: {
    display: 'flex',
  },
});
